import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate(); 

  useEffect(() => {
    const storedUser = localStorage.getItem('data_store');

    if (!storedUser) {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return <>{children}</>;
};

export default ProtectedRoute;